import { Grommet, ThemeType } from 'grommet';
import { gel2Themes, GlobalStyle } from '@snsw-gel/react';
import customTheme from 'app/theme/custom';
import useAgencyBranding from 'app/hooks/useAgencyBranding';

interface Props {
  theme?: ThemeType;
  children: React.ReactNode;
}

const AppThemeProvider: React.FC<Props> = ({ theme, children }) => {
  const { branding } = useAgencyBranding();
  const themes = branding?.theme ?? gel2Themes;

  return (
    <Grommet theme={theme} plain>
      <GlobalStyle themes={themes}>{children}</GlobalStyle>
    </Grommet>
  );
};

AppThemeProvider.defaultProps = {
  theme: customTheme,
};

export default AppThemeProvider;
